import { render } from "./MessageAdd.vue?vue&type=template&id=0d4dc8d6&scoped=true"
import script from "./MessageAdd.vue?vue&type=script&lang=js"
export * from "./MessageAdd.vue?vue&type=script&lang=js"

import "./MessageAdd.vue?vue&type=style&index=0&id=0d4dc8d6&lang=css"
import "./MessageAdd.vue?vue&type=style&index=1&id=0d4dc8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4dc8d6"]])

export default __exports__